import { REQUEST_SERVICES_BY_CATEGORY } from "constants/option";
import { RequestServiceInputType } from "pages/OptionCreate/type";

const genId = (type: "create" | "update") => (type === "update" ? "new_" + crypto.randomUUID() : crypto.randomUUID());

export const INITIAL_REQUEST_SERVICES = (type: "create" | "update"): RequestServiceInputType[] => [
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_WORK.list[0],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_WORK.list[1],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_WORK.list[2],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_HANDOVER.list[0],
    checked: false,
    usingSpans: [],
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_HANDOVER.list[1],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.BEFORE_SITE_HANDOVER.list[2],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.OFFICE_SETUP.list[0],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.OFFICE_SETUP.list[1],
    checked: false,
    usingSpans: [],
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.OFFICE_SETUP.list[2],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[0],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[1],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[2],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[3],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[4],
    checked: false,
    usingSpans: [],
    editable: true,
  },
  {
    id: genId(type),
    content: REQUEST_SERVICES_BY_CATEGORY.LAND_USE.list[5],
    checked: false,
    usingSpans: [],
    editable: true,
  },
];
